import useModal, { ModalProps } from '@carvana/ds-modal';
import { useEffect } from 'react';
import { modalZIndex } from '~/constants/common/zIndex';

export type DsModalProps = ModalProps & {
  isOpen: boolean;
  onClose: () => void;
  onModalMount?: (isMounted: boolean) => void;
};

/**
 * A wrapper component for the ds-modal library that integrates with the existing ModalContext.
 * It synchronizes the state between the context and ds-modal, and provides
 * a consistent interface for all modals.
 */

export default function DsModal({
  children,
  divLine = false,
  isOpen,
  onClose,
  onModalMount,
  zIndex = modalZIndex,
  ...props
}: DsModalProps) {
  const { Modal, openModal, closeModal, isOpen: modalIsOpen } = useModal();

  // One-way sync: context controls modal state
  useEffect(() => {
    if (isOpen) {
      openModal();
    } else {
      closeModal();
    }
  }, [isOpen, openModal, closeModal]);

  // Notify parent component about modal mount state
  useEffect(() => {
    onModalMount?.(modalIsOpen);
  }, [modalIsOpen, onModalMount]);

  return (
    <Modal divLine={divLine} onClose={onClose} zIndex={zIndex} {...props}>
      {children}
    </Modal>
  );
}
